import {CARD_TYPE, DATA_SOURCE_TYPE, INDEX_DROP_TYPE, SPREAD_SHEET_TYPE} from "@/option/common/dict";

export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const website = {
  isDemo: false,
  isDemoTip: '演示环境不允许操作',
  title: '数据大屏',
  name: 'WELCOME TO SCREEN-DATA',
  subName: '可视化数据大屏（演示环境-请勿放生产数据）',
  url: 'https://data.avuejs.com/api/blade-visual',
  autoSave: false,
  autoSaveTime: 60000,
  tabsList: [0, 1, 2, 3, 4, 5, 6],
  componentsList: [],
  baseList:
    [
      {
        label: '图表',
        icon: 'icon-bar',
        children: [{
          label: '通用型',
          option: {
            name: "通用型",
            title: "通用型",
            icon: 'icon-bar',
            img: '/img/assets/text5.png',
            dataType: 1,
            "dataMethod": 'get',
            data: {
              "categories": [
                "苹果",
                "三星",
                "小米",
                "oppo",
                "vivo"
              ],
              "series": [{
                name: "手机品牌",
                data: [
                  1000879,
                  3400879,
                  2300879,
                  5400879,
                  3400879
                ]
              }]
            },
            echartFormatter: "(data,params)=>{\nconsole.log(data);\nreturn {\n            title: {\n\t\t\t\t textStyle: {\n\t\t\t\t\tfontWeight: 'normal',      \n\t\t\t\t\tcolor: '#fff'\n\t\t\t\t},\n                text: 'ECharts 入门示例'\n            },\n            tooltip: {},\n            legend: {\n                data:['销量'],\n\t\t\t\ttextStyle: {\n\t\t\t\t\tfontWeight: 'normal',      \n\t\t\t\t\tcolor: '#fff'\n\t\t\t\t},\n            },\n            xAxis: {\n                data: [\'衬衫\',\'羊毛衫\',\'雪纺衫\',\'裤子\',\'高跟鞋\',\'袜子\']\n            },\n            yAxis: {},\n            series: [{\n                name: '销量',\n                type: 'bar',\n                data: [5, 20, 36, 10, 10, 20]\n            }]\n        };\n}",
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            url: "",
            component: {
              width: 600,
              height: 300,
              name: "common",
              prop: "common",
            },
          }
        }, {
          label: 'datav',
          option: {
            name: "datav",
            title: "datav",
            icon: 'icon-datav',
            img: '/img/assets/text6.png',
            dataType: 0,
            "dataMethod": 'get',
            data: {
              value: 66
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            echartFormatter: "(data,params)=>{\n  console.log(data);\n  return {\n    config:{\n\t    data: [66] \n\t  }\n  }\n}",
            component: {
              width: 150,
              height: 200,
              name: "datav",
              prop: "datav",
            },
            option: {
              is: 'dv-water-level-pond'
            }
          }
        }, {
          label: '柱形图',
          option: {
            name: "柱状图",
            title: "柱状图",
            icon: 'icon-bar',
            img: '/img/assets/bar.png',
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_common',
            },
            data: {
              categories: [
                "苹果",
                "三星",
                "小米",
                "oppo",
                "vivo"
              ],
              series: [{
                name: "手机品牌",
                data: [
                  1000879,
                  3400879,
                  2300879,
                  5400879,
                  3400879
                ]
              }]
            },
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "bar",
              prop: "bar",
            },
            option: {
              gridX: 90,
              gridY: 47,
              gridX2: 43,
              gridY2: 25,
              legend: true,
              tipShow: true,
              scrollXFlag: false,
              xAxisShow: true,
              yAxisShow: true,
              barWidth: 30,
              barRadius: 8,
              barColor: [{
                color1: "#83bff6",
                color2: "#188df0",
                postion: 90
              }, {
                color1: "#23B7E5",
                color2: "#564AA3",
                postion: 50,
              }],
              barMinHeight: 2
            }
          }
        }, {
          label: '3D柱形图',
          option: {
            name: "3D柱状图",
            title: "3D柱状图",
            icon: 'icon-bar',
            img: '/img/assets/bar.png',
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_common',
            },
            data: {
              categories: [
                "苹果",
                "三星",
                "小米",
                "oppo",
                "vivo"
              ],
              series: [{
                name: "手机品牌",
                data: [
                  1000879,
                  3400879,
                  2300879,
                  5400879,
                  3400879
                ]
              }]
            },
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "bar3D",
              prop: "bar3D",
            },
            option: {
              gridX: 90,
              gridY: 47,
              gridX2: 43,
              gridY2: 25,
              legend: true,
              tipShow: true,
              scrollXFlag: false,
              xAxisShow: true,
              yAxisShow: true,
              barWidth: 30,
              barRadius: 8,
              barColor: [{
                color1: "#83bff6",
                color2: "#188df0",
                postion: 90
              }, {
                color1: "#23B7E5",
                color2: "#564AA3",
                postion: 50,
              }],
              barMinHeight: 2
            }
          }
        }, {
          label: '3D棱柱图',
          option: {
            name: "3D棱柱图",
            title: "3D棱柱图",
            icon: 'icon-bar',
            img: '/img/assets/bar.png',
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_common',
            },
            data: {
              categories: [
                "苹果",
                "三星",
                "小米",
                "oppo",
                "vivo"
              ],
              series: [{
                name: "手机品牌",
                data: [
                  1000879,
                  3400879,
                  2300879,
                  5400879,
                  3400879
                ]
              }]
            },
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "prism3D",
              prop: "prism3D",
            },
            option: {
              topInterval: 30,
            }
          }
        }, {
          label: '折线图',
          option: {
            name: "折线图",
            title: "折线图",
            icon: 'icon-line',
            img: '/img/assets/line.png',
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: '',
              // 增加的配置
              add: [
                INDEX_DROP_TYPE.DIMENSION,
                INDEX_DROP_TYPE.GROUP,
                {
                  code: INDEX_DROP_TYPE.METRICS,
                  name: '主指标（可多选）'
                },
                {
                  code: INDEX_DROP_TYPE.METRIC_L,
                  name: '次指标（可多选）'
                },
                INDEX_DROP_TYPE.REFERENCE,
                INDEX_DROP_TYPE.ASSIST
              ],
              del: []
            },
            data: {
              "categories": [
                "08-01",
                "08-05",
                "08-10",
                "08-15",
                "08-20"
              ],
              "series": [
                {
                  "name": "产量",
                  "type": "line",
                  "data": [
                    79,
                    69,
                    79,
                    59,
                    39
                  ]
                },
                {
                  "name": "销量",
                  "type": "line",
                  "data": [
                    29,
                    59,
                    39,
                    19,
                    39
                  ]
                },
                {
                  "name": "库存",
                  "type": "line",
                  "data": [
                    89,
                    79,
                    59,
                    99,
                    49
                  ]
                }
              ]
            },
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "line",
              prop: "line",
            },
            option: {
              gridX: 84,
              gridY: 35,
              gridX2: 26,
              gridY2: 31,
              legend: true,
              tipShow: true,
              scrollXFlag: false,
              xAxisShow: true,
              yAxisShow: true,
              subYAxis: {
                yAxisShow: false,
              },
              barColor: [{
                color1: "#83bff6",
                color2: "#188df0",
                postion: 90
              }, {
                color1: "#23B7E5",
                color2: "#564AA3",
                postion: 50
              }],
              areaColor: [{
                color1: "#83bff6",
                color2: "#188df0",
                position: 90
              }],
              symbolShow: true,
              symbolSize: 6,
              smooth: true,
            }
          }
        }, {
          label: '饼图',
          option: {
            name: "饼图",
            title: "饼图",
            icon: 'icon-pie',
            img: '/img/assets/pie.png',
            // 指标维度的动态配置
            dynamicConfig: {
              // 增加的配置
              add: [
                INDEX_DROP_TYPE.DIMENSION,
                INDEX_DROP_TYPE.METRICS,
                INDEX_DROP_TYPE.ASSIST,
                INDEX_DROP_TYPE.TOTAL
              ],
              del: []
            },
            data: [{
              name: "产量",
              value: 79
            }, {
              name: "销量",
              value: 59,
            }, {
              name: "库存",
              value: 89,
            }],
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "pie",
              prop: "pie",
            },
            option: {
              legend: true,
              labelShow: true,
              barColor: [
                {
                  color1: "#83bff6"
                },
                {
                  color1: "#23B7E5"
                },
                {
                  color1: "rgba(154, 168, 212, 1)"
                },
                {
                  color1: "#188df0"
                },
                {
                  color1: "#564AA3"
                }
              ]
            }
          }
        }, {
          label: '象形图',
          option: {
            title: "象形图",
            name: "象形图",
            icon: "icon-pictorialBar",
            img: '/img/assets/bar2.png',
            data: [{
              name: "苹果",
              value: 1000879,
            }, {
              name: "三星",
              value: 3400879,
            }, {
              name: "小米",
              value: 2300879,
            }, {
              name: "oppo",
              value: 5400879,
            }, {
              name: "大疆",
              value: 3000,
            }, {
              name: "抖音",
              value: 2000,
            }],
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "pictorialbar",
              prop: "pictorialbar",
            },
            option: {
              symbolSize: 30,
              split: 30,
              symbol: '/img/source/source256.png',
              labelFontSize: '24',
              labelColor: '#4dffff',
              fontSize: 20,
              color: '#fff',
              gridX: 76,
              gridY: 4,
              gridX2: 127,
              gridY2: 0
            }
          }
        }, {
          label: '雷达图',
          option: {
            title: "雷达图",
            name: "雷达图",
            icon: "icon-radar",
            img: '/img/assets/radar.png',
            dataType: 0,
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_dist'
            },
            data: {
              "indicator": [
                {
                  "name": "资产负债率",
                  "max": 20,
                  color: "black"
                },
                {
                  "name": "净资产收益率",
                  "max": 20,
                  color: "black"
                },
                {
                  "name": "营业现金比率",
                  "max": 20,
                  color: "black"
                },
                {
                  "name": "全员劳动生产率",
                  "max": 20,
                  color: "black"
                },
                {
                  "name": "研发投入强度",
                  "max": 20,
                  color: "black"
                }
              ],
              "series": [
                {
                  "data": [
                    {
                      "value": [
                        20,
                        6,
                        14,
                        2,
                        10
                      ],
                      "name": "五率"
                    },
                  ]
                }
              ]
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 970,
              height: 400,
              name: "radar",
              prop: "radar",
            },
            option: {
              width: '100%',
              height: 600,
              color: '#fff',
              fontSize: 18,
              areaOpacity: 0.3,
              legend: true,
              splitAreaShow: true,
              tipShow: true,
              barColor: [{
                color1: "#564AA3",
              },
                {
                  color1: "#188df0",
                }]
            },
          }
        }, {
          label: '散点图',
          option: {
            title: "散点图",
            name: "散点图",
            icon: "icon-scatter",
            img: '/img/assets/scatter.png',
            dataType: 0,
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_dist'
            },
            data: [{
              data: [
                [1, 8.04],
                [2, 6.95]
              ]
            },
              {
                data: [
                  [1, 4.04],
                  [2, 3.95]
                ]
              }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "scatter",
              prop: "scatter",
            },
            option: {
              gridX: 26,
              gridY: 12,
              gridX2: 14,
              gridY2: 30,
              lineSize: 25,
              tipShow: true,
              labelShow: true,
              legend: true,
              xAxisSplitLineShow: true,
              yAxisSplitLineShow: true,
              barColor: [{
                postion: 0.2,
                color1: '#91c7ae'
              },
                {
                  postion: 0.8,
                  color1: '#63869e'
                },
                {
                  postion: 1,
                  color1: '#c23531'
                }]
            }
          }
        }, {
          label: '漏斗图',
          option: {
            title: "漏斗图",
            name: "漏斗图",
            icon: "icon-funnel",
            img: '/img/assets/funnel.png',
            dataType: 0,
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_dist'
            },
            data: [
              {value: 60, name: 'Visit'},
              {value: 40, name: 'Inquiry'},
              {value: 20, name: 'Order'},
              {value: 80, name: 'Click'},
              {value: 100, name: 'Show'}
            ],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 450,
              height: 350,
              name: "funnel",
              prop: "funnel",
            },
            option: {
              legend: true,
              labelShow: true,
              tipShow: true,
              barColor: [{
                color1: "#83bff6",
              },
                {
                  color1: "#23B7E5",
                },
                {
                  color1: "rgba(154, 168, 212, 1)",
                },
                {
                  color1: "#188df0",
                },
                {
                  color1: "#564AA3",
                }]
            }
          }
        }, {
          label: '地图',
          option: {
            name: "地图",
            title: "地图",
            icon: "icon-map",
            img: '/img/assets/map.png',
            dataType: 0,
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_map'
            },
            data: [
              {
                name: "测试坐标1",
                value: 1,
                lng: 118.30078125,
                lat: 36.91915611148194,
                zoom: 1
              },
              {
                name: "测试坐标2",
                value: 1,
                lng: 112.21435546875,
                lat: 37.965854128749434,
                zoom: 1
              }
            ],
            formatter: "(name,data)=>{\n  return '名称:'+name.data.name+name.data.value\n}",
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 800,
              height: 607,
              name: "map",
              prop: "map",
            },
            option: {
              tipBackgroundColor: "rgba(13, 255, 255, .5)",
              tipColor: "rgba(217, 38, 10, 1)",
              tipFontSize: "30",
              borderWidth: 1,
              type: 0,
              borderColor: "#0dffff",
              areaColor: "rgba(6, 29, 51, 0.59)",
              banner: true,
              bannerTime: 3000,
              fontSize: 14,
              zoom: 1,
              mapScale: 1,
              roam: true,
              empAreaColor: "rgba(35, 183, 229, 0.42)",
              empColor: "rgba(217, 38, 10, 1)",
              index: "894edc1d-d2f0-4616-962c-8e61083ada71",
              mapData: "",
              color: "rgba(13, 255, 255, 1)",
            }
          }
        }, {
          label: '矩形图',
          option: {
            name: "矩形图",
            title: "矩形图",
            icon: 'icon-juxing',
            img: '/img/assets/rectangle.png',// 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_dist'
            },
            data: [
              {
                "name": "原材料",
                "value": 560
              },
              {
                "name": "辅助材料",
                "value": 500
              },
              {
                "name": "动力电",
                "value": 150
              },
              {
                "name": "制造费用",
                "value": 100
              },
            ],
            dataType: 0,
            component: {
              width: 754,
              height: 377,
              name: "rectangle",
              prop: "rectangle",
            },
            option: {
              tipShow: true,
              labelShow: true,
              labelShowColor: '#fff',
              labelShowFontSize: 14
            }
          }
        }, {
          label: '自定义Vue组件',
          option: {
            name: "自定义Vue组件",
            title: "自定义Vue组件",
            icon: 'icon-bar',
            img: '/img/assets/text4.png',
            dataType: 0,
            data: {
              name: "avue"
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 800,
              height: 500,
              name: "vue",
              prop: "vue",
            },
            option: {
              content: "<template>\n    <div class=\"test\">\n        <h1 @click=\"handleClick\">{{dataChart}}</h1>\n    </div>\n</template>\n<script>\nexport default{\n    data(){\n        return{\n            \n        }\n    },\n    created(){\n        console.log(this);\n        //通过setDataIndicators方法抛出需要用的指标选项，包括['维度','分组','指标'，'辅助指标'，'总值指标']五种\n        this.$emit('setDataIndicators',['维度','分组','指标'])\n    },\n    methods:{\n        handleClick(){\n            this.$message.success(this.dataChart.name)\n        }\n    }\n}\n</script>\n<style>\n    .test{\n        text-align:center;\n        color:red;\n        font-size:40px;\n    }\n</style>"
            }
          }
        }, {
          label: '定时器',
          option: {
            name: "定时器",
            title: "定时器",
            icon: 'icon-datetime',
            img: '/img/assets/time.png',
            echartFormatter: "(refs)=>{\n    console.log(refs)\n}",
            component: {
              width: 100,
              height: 100,
              name: 'time',
              prop: 'time',
            },
            option: {
              time: 0
            }
          }
        }, {
          label: '数据集',
          option: {
            name: "数据集",
            title: "数据集",
            icon: 'icon-text',
            img: '/img/assets/time.png',
            component: {
              width: 100,
              height: 100,
              name: 'data',
              prop: 'data',
            },
            option: {}
          }
        }]
      },
      {
        label: '文字',
        icon: 'icon-text',
        children: [
          // {
          //   label: '文本框',
          //   option: {
          //     title: "文本框",
          //     name: "文本框",
          //     icon: 'icon-text',
          //     img: '/img/assets/text.png',
          //     dataType: 0,
          //     dataFormatter: "",
          //     dataQuery: "",
          //     dataHeader: "",
          //     stylesFormatter: "",
          //     child: {
          //       index: [],
          //       paramName: ""
          //     },
          //     data: {
          //       value: '文本框'
          //     },
          //     component: {
          //       width: 135,
          //       height: 40,
          //       name: "text",
          //       prop: "text"
          //     },
          //     option: {
          //       textAlign: "center",
          //       fontSize: 26,
          //       fontWeight: "normal",
          //       color: "#fff"
          //     },
          //   },
          // },
          {
            label: '跑马灯',
            option: {
              title: "跑马灯",
              name: "跑马灯",
              icon: 'icon-scroll',
              img: '/img/assets/text2.png',
              top: 0,
              left: 0,
              dataType: 0,
              data: {
                value: "跑马灯"
              },
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 100,
                height: 50,
                name: "text",
                prop: "text"
              },
              option: {
                scroll: true,
                speed: 70,
                textAlign: "center",
                fontSize: 26,
                fontWeight: "normal",
                color: "#fff"
              },
            },
          }, {
            label: '超链接',
            option: {
              title: "超链接",
              name: "超链接",
              icon: 'icon-link',
              img: '/img/assets/text3.png',
              top: 0,
              left: 0,
              data: {
                value: "超链接"
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 100,
                height: 50,
                name: "text",
                prop: "text"
              },
              option: {
                link: true,
                linkHref: 'http://avue.top',
                linkTarget: '_self',
                textAlign: "center",
                fontSize: 26,
                fontWeight: "normal",
                color: "#fff"
              },
            },
          }, {
            label: '实时时间',
            option: {
              name: "实时时间",
              title: "实时时间",
              icon: 'icon-datetime',
              img: '/img/assets/datetime.png',
              top: 78,
              left: 1604,
              component: {
                width: 250,
                height: 50,
                name: "datetime",
                prop: "datetime",
              },
              option: {
                format: 'yyyy-MM-dd HH:mm:ss',
                color: "#fff",
                textAlign: 'left',
                fontSize: 24,
                fontWeight: "normal"
              }
            },
          }]
      },
      {
        label: '媒体',
        icon: 'icon-img',
        children: [{
          label: '图片',
          option: {
            title: "图片",
            name: "图片",
            icon: 'icon-img',
            img: '/img/assets/img.png',
            top: 0,
            left: 0,
            dataType: 0,
            data: {
              value: '/img/img-default.png'
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 180,
              height: 120,
              name: 'img',
              prop: 'img',
            },
            option: {
              duration: '10000',
              opacity: 1
            }
          }
        }, {
          label: '图片框',
          option: {
            title: "图片框",
            name: "图片框",
            icon: 'icon-img',
            img: '/img/assets/imgborder.png',
            top: 0,
            left: 0,
            dataType: 0,
            data: "/img/border/border1.png",
            component: {
              width: 140,
              height: 140,
              name: "imgborder",
              prop: "imgborder",
            },
            option: {
              backgroundColor: 'rgba(180, 181, 198, 0.1)',
            }
          }
        }, {
          label: '轮播图',
          option: {
            title: "轮播图",
            name: "轮播图",
            icon: 'icon-banner',
            img: '/img/assets/swiper.png',
            top: 0,
            left: 0,
            dataType: 0,
            data: [{
              value: 'https://img.alicdn.com/tfs/TB1v28TC8v0gK0jSZKbXXbK2FXa-1880-640.jpg',
            }, {
              value: 'https://img.alicdn.com/tfs/TB1uevcCrj1gK0jSZFuXXcrHpXa-1880-640.jpg',
            }, {
              value: 'http://www.w3school.com.cn/i/movie.ogg'
            }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 670,
              height: 370,
              name: "swiper",
              prop: "swiper"
            },
            option: {
              type: '',
              interval: 5000,
              opacity: 100,
              indicator: 'none',
              autoplay: true,
              controls: true,
              loop: true
            },
          }
        }, {
          label: 'iframe',
          option: {
            title: "iframe",
            name: "iframe",
            icon: 'icon-iframe',
            img: '/img/assets/iframe.png',
            top: 0,
            left: 0,
            component: {
              width: 670,
              height: 370,
              option: {},
              name: "iframe",
              prop: "iframe"
            },
            dataType: 0,
            data: {
              value: 'https://avuejs.com'
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            option: {},
          }
        }, {
          label: 'video播放器',
          option: {
            title: "video",
            name: "video",
            icon: 'icon-video',
            img: '/img/assets/video.png',
            top: 0,
            left: 0,
            dataType: 0,
            data: {
              value: 'http://www.w3school.com.cn/i/movie.ogg'
            },
            option: {
              autoplay: false,
              controls: true,
              loop: true,
              poster: ''
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 670,
              height: 370,
              name: "video",
              prop: "video"
            },
          }
        }, {
          label: 'hls播放器',
          option: {
            title: "hls",
            name: "hls",
            icon: 'icon-video',
            img: '/img/assets/video.png',
            top: 0,
            left: 0,
            dataType: 0,
            data: {
              value: 'https://open.ys7.com/v3/openlive/E10668433_1_1.m3u8?expire=1664027961&id=363444666731335680&t=346b970f0d5cb5d5b5e4734d966275a61fb9efd5038c7a75b7435423c5716908&ev=100'
            },
            option: {
              autoplay: true
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 670,
              height: 370,
              option: {},
              name: "clapper",
              prop: "clapper"
            },
          }
        }]
      },
      {
        label: '指标',
        icon: 'icon-flop',
        children: [{
          label: '翻牌器',
          option: {
            title: "翻牌器",
            name: "翻牌器",
            icon: 'icon-flop',
            img: '/img/assets/flop.png',
            top: 0,
            left: 0,
            dataType: 0,
            child: {
              index: [],
              paramName: ""
            },
            data: {
              value: '12345'
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 445.6,
              height: 86.56,
              name: "flop",
              prop: "flop",
            },
            option: {
              textAlign: 'center',
              paddingLeft: 10,
              marginLeft: 10,
              border: true,
              borderColor: "#fff",
              borderWidth: 10,
              backgroundBorder: "/img/border/border1.png",
              fontSize: 50,
              color: "#afdef2",
              backgroundColor: "#132d4f"
            },
          }
        }, {
          label: '颜色块',
          option: {
            title: "颜色块",
            name: "颜色块",
            icon: 'icon-flop',
            img: '/img/assets/flop2.png',
            "child": {
              "index": [],
              "paramName": ""
            },
            top: 0,
            left: 0,
            dataType: 0,
            data: [{
              backgroundColor: '#67C23A',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }, {
              backgroundColor: '#409EFF',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }, {
              backgroundColor: '#E6A23C',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }, {
              backgroundColor: '#F56C6C',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }, {
              backgroundColor: '#7232dd',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }, {
              backgroundColor: 'blue',
              prefixText: "某某某总人数",
              value: '12345',
              suffixText: '人',
            }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 543.04,
              height: 196.28,
              name: "flop",
              prop: "flop",
            },
            option: {
              width: 180,
              whole: true,
              fontSize: 28,
              prefixFontSize: 13,
              backgroundColor: "#F56C6C",
              suffixFontSize: 18,
              marginTop: 10,
              marginLeft: 5,
              paddingTop: 10,
              paddingLeft: 30,
              color: "#fff",
              suffixInline: true,
              fontWeight: "bolder"
            },
          }
        }, {
          label: '环形图',
          option: {
            title: "环形图",
            name: "环形图",
            icon: 'icon-circle',
            img: '/img/assets/progress.png',
            top: 0,
            left: 0,
            dataType: 0,
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_common',
              // 增加的配置
              add: [
                INDEX_DROP_TYPE.TOTAL
              ],
              del: []
            },
            data: {
              label: "人数增涨",
              value: 40,
              data: 80
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 300,
              height: 300,
              name: "progress",
              prop: "progress"
            },
            option: {
              type: "circle",
              color: "#60d3da",
              fontSize: 25,
              suffixColor: "#60d3da",
              strokeWidth: 20,
              fontWeight: "normal",
              borderColor: "#60d3da",
              suffixFontSize: 30,
              FontWeight: "normal"
            },
          }
        }, {
          label: '进度条',
          option: {
            title: "进度条",
            name: "进度条",
            icon: 'icon-progress',
            img: '/img/assets/progress2.png',
            top: 0,
            left: 0,
            data: {
              name: "人数增涨",
              value: 40,
              data: ['80']
            },
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 500,
              height: 100,
              name: "progress",
              prop: "progress"
            },
            option: {
              type: "line",
              color: "#60d3da",
              fontSize: 25,
              suffixColor: "#60d3da",
              strokeWidth: 10,
              fontWeight: "normal",
              borderColor: "#60d3da",
              suffixFontSize: 30,
              FontWeight: "normal"
            },
          }
        }, {
          label: '仪表盘',
          option: {
            title: "仪表盘",
            icon: 'icon-gauge',
            img: '/img/assets/gauge.png',
            name: "仪表盘",
            dataType: 0,
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_panel'
            },
            data: [
              {
                "value": 85.2,
                "name": "同期",
                "title": {
                  "offsetCenter": [
                    "-40%",
                    "80%"
                  ]
                },
                "detail": {
                  "offsetCenter": [
                    "-40%",
                    "95%"
                  ]
                }
              }, {
                "value": 20,
                "name": "本期",
                "title": {
                  "offsetCenter": [
                    "-40%",
                    "80%"
                  ]
                },
                "detail": {
                  "offsetCenter": [
                    "-40%",
                    "95%"
                  ]
                }
              }

            ],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 390,
              height: 314,
              name: "gauge",
              prop: "gauge"
            },
            option: {
              assistTip: true,
              lineSize: 8,
              axisLabelShow: true,
              axisLabelFontSize: 20,
              nameFontSize: 40,
              lineColor: "#eee",
              labelColor: '#fff',
              intervalAuto: 'auto',
              axisTickShow: true,
              splitLineShow: true,
              legend: false,
              labelShow: true,
              leftOffset: 100,
              topOffset: 100,
              pointerWidth: 4,
              pointerLength: '40%',
              axisLabelDistance: 14
            },
          },
        }, /* {
        label: '下拉筛选',
        option: {
          title: "下拉筛选",
          icon: 'icon-gauge',
          img: '/img/assets/gauge.png',
          name: "下拉筛选",
          dataType: 0,
          data: [
            {
              value: 'Option1',
              label: '选项一',
            },
            {
              value: 'Option2',
              label: '选项二',
            },
            {
              value: 'Option3',
              label: '选项三',
            },
          ],
          dataFormatter: "",
          dataQuery: "",
          dataHeader: "",
          stylesFormatter: "",
          component: {
            width: 390,
            height: 314,
            name: "select",
            prop: "select"
          },
          option: {
            multiple: false,
            placeHolder: '请选择'
          },
        },
      },  */{
          label: '字符云',
          option: {
            title: "字符云",
            name: "字符云",
            icon: "icon-wordCloud",
            img: '/img/assets/wordcloud.png',
            top: 0,
            left: 0,
            dataType: 0,
            // 指标维度的动态配置
            dynamicConfig: {
              // 增加的配置
              add: [
                INDEX_DROP_TYPE.DIMENSION,
                INDEX_DROP_TYPE.METRICS
              ],
              del: []
            },
            data: [{
              name: '三星',
              value: '1'
            }, {
              name: '小米',
              value: '10'
            }, {
              name: '华为',
              value: '20'
            }, {
              name: 'oppo',
              value: '30'
            }, {
              name: '抖音',
              value: '40'
            }, {
              name: '快手',
              value: '50'
            }, {
              name: '淘宝',
              value: '60'
            }, {
              name: '百度',
              value: '70'
            }, {
              name: '京东',
              value: '80'
            }, {
              name: '天猫',
              value: '100'
            }, {
              name: '中材',
              value: '110'
            }, {
              name: '字符',
              value: '200',
              textStyle: {
                color: 'red'
              }
            }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              name: "wordcloud",
              prop: "wordcloud",
              width: 600,
              height: 300,
            },
            option: {
              minFontSize: 30,
              maxFontSize: 80,
              split: 30,
              rotate: false,
            }
          }
        }]
      },
      {
        label: '表格',
        icon: 'icon-table',
        children: [{
          label: '表格',
          option: {
            title: "表格",
            name: "表格",
            icon: 'icon-table',
            img: '/img/assets/table.png',
            top: 0,
            left: 0,
            dataType: 0,
            // 指标维度的动态配置
            dynamicConfig: {
              // 增加的配置
              add: [
                INDEX_DROP_TYPE.COLUMNS,
                INDEX_DROP_TYPE.GROUP,
                INDEX_DROP_TYPE.ASSIST
              ],
              del: []
            },
            data: [{
              type1: '数据1',
              type2: '数据1'
            }, {
              type1: '数据2',
              type2: '数据2'
            }, {
              type1: '数据3',
              type2: '数据3'
            }, {
              type1: '数据4',
              type2: '数据4'
            }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 700,
              height: 350,
              name: "table",
              prop: "table",
            },
            option: {
              showHeader: true,
              columnShow: true,
              columnViews: true,
              headerBackground: "#050e18",
              headerColor: "#69bfe7",
              headerTextAlign: "center",
              nthColor: "#09192c",
              bodyBackground: "rgba(0, 0, 0, 0.01)",
              bodyColor: "#69bfe7",
              bodyTextAlign: "center",
              align: "center",
              headerAlign: "center",
              header: false,
              scrollSpeed: 1,
              fontSize: 15,
              count: 4,
              index: true,
              column: [
                {
                  label: "列1",
                  prop: "type1",
                  $index: 0
                },
                {
                  label: "列2",
                  prop: "type2",
                  $index: 1
                },
                {
                  label: "列3",
                  prop: "type3",
                  $index: 2
                },
                {
                  label: "列4",
                  prop: "type4",
                  $index: 3
                }
              ],
              othColor: "#142a40",
              headerFontSize: 20,
              bodyFontSize: 18
            }
          }
        }, {
          label: '选项卡',
          option: {
            title: "选项卡",
            name: "选项卡",
            icon: "icon-tabs",
            img: '/img/assets/tabs.png',
            child: {
              index: [],
              paramName: ""
            },
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            dataType: 0,
            data: [
              {
                label: "选项卡1",
                value: "1"
              },
              {
                label: "选项卡2",
                value: "2"
              }
            ],
            component: {
              width: 356,
              height: 46,
              name: "tabs",
              prop: "tabs"
            },
            option: {
              type: 'tabs',
              color: "#eee",
              empColor: "#4dffff",
              fontSize: 20,
              split: 8,
              empBackgroundImage: "/img/banner/banner5.png",
              backgroundImage: "/img/banner/banner4.png"
            },
          },
        },]
      },
      {
        label: '边框',
        icon: 'icon-biankuang',
        children: [{
          label: '边框1',
          option: {
            title: "边框1",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_01.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 1,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框2',
          option: {
            title: "边框2",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_02.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 2,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框3',
          option: {
            title: "边框3",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_03.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 3,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框4',
          option: {
            title: "边框4",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_04.png',
            top: 0,
            left: 0,
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 4,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框5',
          option: {
            title: "边框5",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_05.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 5,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框6',
          option: {
            title: "边框6",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_06.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 6,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框7',
          option: {
            title: "边框7",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_07.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 7,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框8',
          option: {
            title: "边框8",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_08.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 8,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框9',
          option: {
            title: "边框9",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_09.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 9,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框10',
          option: {
            title: "边框10",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_10.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 10,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框11',
          option: {
            title: "边框11",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_11.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 11,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }, {
          label: '边框12',
          option: {
            title: "边框12",
            name: "datav",
            icon: 'icon-biankuang',
            img: '/img/assets/borderBox/borderBox_12.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 300,
              height: 150,
              name: "borderBox",
              prop: "borderBox"
            },
            option: {
              type: 12,
              color1: '#83bff6',
              color2: '#00CED1',
              dur: undefined
            }
          }
        }]
      },
      {
        label: '装饰',
        icon: 'icon-jianzhuzhuangshi',
        children: [{
          label: '装饰1',
          option: {
            title: "装饰1",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_01.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 1,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰2',
          option: {
            title: "装饰2",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_02.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 2,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰3',
          option: {
            title: "装饰3",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_03.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 3,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰4',
          option: {
            title: "装饰4",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_04.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 4,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰5',
          option: {
            title: "装饰5",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_05.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 5,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰6',
          option: {
            title: "装饰6",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_06.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 6,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰7',
          option: {
            title: "装饰7",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_07.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 7,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰8',
          option: {
            title: "装饰8",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_08.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 8,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰9',
          option: {
            title: "装饰9",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_09.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 440.5,
              height: 377.65,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 9,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰10',
          option: {
            title: "装饰10",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_10.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 10,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰11',
          option: {
            title: "装饰11",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_11.png',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 670,
              height: 370,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 11,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }, {
          label: '装饰12',
          option: {
            title: "装饰12",
            name: "datav",
            icon: 'icon-jianzhuzhuangshi',
            img: '/img/assets/decorate/decorate_12.gif',
            top: 0,
            left: 0,
            data: {},
            component: {
              width: 430,
              height: 430,
              name: "decoration",
              prop: "decoration"
            },
            option: {
              type: 12,
              color1: '#00CED1',
              color2: '#FAD400',
              dur: undefined
            }
          }
        }]
      },
      {
        label: '二次开发',
        icon: 'icon-biankuang',
        children: [{
          label: '自定义组件',
          option: {
            name: "自定义组件",
            title: "自定义组件",
            ico: 'icon-bar',
            img: '/img/assets/text4.png',
            dataType: 0,
            data: [],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 800,
              height: 500,
              name: "test",
              prop: "test",
            },
            option: {
              fontSize: 20,
            }
          }
        }, {
          label: '滚动选项卡',
          option: {
            name: "滚动选项卡",
            title: "滚动选项卡",
            icon: 'icon-bar',
            img: '/img/assets/text4.png',
            dataType: 0,
            data: [{
              text: '领导调研',
              list: [
                "https://img.alicdn.com/tfs/TB1v28TC8v0gK0jSZKbXXbK2FXa-1880-640.jpg",
                "https://img.alicdn.com/tfs/TB1uevcCrj1gK0jSZFuXXcrHpXa-1880-640.jpg"
              ]
            }, {
              text: '先进事件',
              list: [
                "https://img.alicdn.com/imgextra/i1/O1CN01NAnI6W1Vf1kZScscd_!!6000000002679-0-tps-2880-1070.jpg",
                "https://img.alicdn.com/imgextra/i2/O1CN011FMQT21RF8u1nHsem_!!6000000002081-0-tps-2880-1070.jpg"
              ]
            }],
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 800,
              height: 400,
              name: "imgTabs",
              prop: "imgTabs",
            },
            option: {
              direction: 'horizontal',
              interval: 3000,
              time: 3000,
              autoplay: true
            }
          }
        }, {
          label: '环图',
          option: {
            name: "环图",
            title: "环图",
            icon: 'icon-pieCircle',
            img: '/img/assets/pieCircle.jpg',
            // 指标维度的动态配置
            dynamicConfig: {
              // 指标维度配置的大分类
              type: 'type_circle',
            },
            data: [{
              name: "苹果",
              value: 1000879,
              url: "http://www.baidu.com"
            }, {
              name: "三星",
              value: 3400879,
              url: "http://www.baidu.com"
            }, {
              name: "小米",
              value: 2300879,
              url: "http://www.baidu.com"
            }, {
              name: "oppo",
              value: 5400879,
              url: "http://www.baidu.com"
            }, {
              name: "大疆",
              value: 3000,
              url: "http://www.baidu.com"
            }],
            dataType: 0,
            dataFormatter: "",
            dataQuery: "",
            dataHeader: "",
            stylesFormatter: "",
            component: {
              width: 600,
              height: 300,
              name: "pieCircle",
              prop: "pieCircle",
            },
            option: {
              legend: true,
              labelShow: true,
              barColor: [
                {
                  color1: "#83bff6"
                },
                {
                  color1: "#23B7E5"
                },
                {
                  color1: "rgba(154, 168, 212, 1)"
                },
                {
                  color1: "#188df0"
                },
                {
                  color1: "#564AA3"
                }
              ]
            }
          }
        },
          {
            label: '带指标卡的环图',
            option: {
              name: "带指标卡的环图",
              title: "环图",
              icon: 'icon-pieCircle',
              img: '/img/assets/pieCircle.jpg',
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_circle'
              },
              data: [
                {
                  name: "产量",
                  value: 79
                }, {
                  name: "销量",
                  value: 59,
                }, {
                  name: "库存",
                  value: 89,
                }
              ],
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "pieCircleIndex",
                prop: "pieCircleIndex",
              },
              option: {
                legend: true,
                labelShow: true,
                legendType: 'indexCard',
                layoutType: 'row',
                legendIcon: 'roundRect',
                legendPosition: 'rl',
                labelPosition: 'inside',
                barColor: [
                  {
                    color1: "#83bff6"
                  },
                  {
                    color1: "#23B7E5"
                  },
                  {
                    color1: "rgba(154, 168, 212, 1)"
                  },
                  {
                    color1: "#188df0"
                  },
                  {
                    color1: "#564AA3"
                  }
                ],
                labelContent: ['维度值', '指标值'],
                cardType: CARD_TYPE.OPT,
                dataSourceType: DATA_SOURCE_TYPE.BIZ,
                selectedColorIndex: 0,
                size: "large",
                colorType: "single",
                valueSize: "mini",
                lineColor: "#3e7aff",
                customColor: "#3e7aff",
                titleFontSize: 14,
                valueFontSize: 20,
                titleColor: '#fff',
                valueColor: '#fff',
                assistColor: '#fff',
                assistFontSize: 12,
                assistDesColor: '#fff',
                assistDesFontSize: 12,
                mainAssistType: 'row',
                layoutNumber: 70,
                xCenter: 50,
                yCenter: 50,
                xRadius: 70,
                yRadius: 80,
                legendW: 25,
                legendH: 14,
                legendFontSize: 18,
                legendFontColor: "#fff",
                mainGap: 14,
                intervalGap: 14,
                showCenterLabel: true,
                tipConfine: true
              }
            }
          },
          {
            label: '双碳3d地图',
            option: {
              name: "双碳3d地图",
              title: "双碳3d地图",
              icon: "icon-map",
              img: '/img/assets/map.png',
              dataType: 0,
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_map'
              },
              data: [
                {
                  name: "测试坐标1",
                  value: 1,
                  lng: 118.30078125,
                  lat: 36.91915611148194,
                  zoom: 1
                },
                {
                  name: "测试坐标2",
                  value: 1,
                  lng: 112.21435546875,
                  lat: 37.965854128749434,
                  zoom: 1
                }
              ],
              formatter: "(name,data)=>{\n  return '名称:'+name.data.name+name.data.value\n}",
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 800,
                height: 607,
                name: "map3D",
                prop: "map3D",
              },
              option: {
                tipBackgroundColor: "rgba(13, 255, 255, .5)",
                tipColor: "rgba(217, 38, 10, 1)",
                tipFontSize: "30",
                borderWidth: 1,
                scale: 87,
                type: 0,
                borderColor: "#0dffff",
                areaColor: "rgba(6, 29, 51, 0.59)",
                banner: true,
                bannerTime: 3000,
                fontSize: 14,
                zoom: 0.5,
                roam: true,
                empAreaColor: "rgba(35, 183, 229, 0.42)",
                empColor: "rgba(217, 38, 10, 1)",
                index: "894edc1d-d2f0-4616-962c-8e61083ada71",
                mapData: "/api/aida-basic/basicConfig/getById?id=100101230917175117008144",
                color: "rgba(13, 255, 255, 1)",
              }
            }
          }, {
            label: '年选择器',
            option: {
              name: "年选择器",
              title: "年选择器",
              icon: "icon-map",
              img: '/img/assets/year.jpg',
              dataType: 0,
              data: [
                {
                  name: "2022",
                  value: 2022,
                },
                {
                  name: "2023",
                  value: 2023,
                }
              ],
              formatter: "(name,data)=>{\n  return '名称:'+name.data.name+name.data.value\n}",
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 300,
                height: 50,
                name: "year",
                prop: "year",
              },
              option: {}
            }
          }, {
            label: '进度图',
            option: {
              name: "进度图",
              title: "进度图",
              icon: "icon-map",
              img: '/img/assets/progress.jpg',
              dataType: 0,
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_common',
              },
              data: [
                {
                  name: "2022",
                  value: 2022,
                },
                {
                  name: "2023",
                  value: 2023,
                }
              ],
              formatter: "(name,data)=>{\n  return '名称:'+name.data.name+name.data.value\n}",
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 300,
                height: 50,
                name: "multiProgress",
                prop: "multiProgress",
              },
              option: {
                itemDistance: 12,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50
                }],
              }
            }
          }, {
            label: '带帽柱状图',
            option: {
              name: "带帽柱状图",
              title: "带帽柱状图",
              icon: 'icon-bar',
              img: '/img/assets/bar.png',
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_common',
              },
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "helmetBar",
                prop: "helmetBar",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                scrollXFlag: false,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                assistTip: true,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '流程图',
            option: {
              name: "流程图",
              title: "流程图",
              icon: 'icon-flow',
              img: '/img/assets/flow.jpg',
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "flowChart",
                prop: "flowChart",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '工厂图片组件',
            option: {
              name: "工厂图片组件",
              title: "工厂图片组件",
              icon: 'icon-flow',
              img: '/img/assets/factoryIcon.jpg',
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "imgMap",
                prop: "imgMap",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '小下拉选择器',
            option: {
              name: "小下拉选择器",
              title: "小下拉选择器",
              icon: 'icon-flow',
              img: '/img/assets/select.jpg',
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "basicSelect",
                prop: "basicSelect",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '横向柱状图',
            option: {
              name: "横向柱状图",
              title: "横向柱状图",
              icon: 'icon-flow',
              img: '/img/assets/horizontalBar.jpg',
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_common',
                add: [{
                  code: INDEX_DROP_TYPE.DIMENSION,
                  name: '维度（多选）',
                  multiple: true
                }]
              },
              data: {
                "categories": [
                  "机电维修费",
                  "吨产品维恀费"
                ],
                "series": [
                  {
                    "name": "同期",
                    "data": [
                      1000,
                      3400
                    ]
                  },
                  {
                    "name": "本期",
                    "data": [
                      1000,
                      3400
                    ]
                  },
                  {
                    "name": "同期实际",
                    "data": [
                      800,
                      2400
                    ]
                  }
                ]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "horizontalBar",
                prop: "horizontalBar",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                scrollXFlag: false,
                xAxisShow: true,
                xAxisLineShow: true,
                yAxisLineShow: true,
                yAxisShow: true,
                assistTip: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '顶部选择器',
            option: {
              name: "顶部选择器",
              title: "顶部选择器",
              icon: 'icon-flow',
              img: '/img/assets/headSelect.jpg',
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "headSelect",
                prop: "headSelect",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          },
          // {
          //   label: '文本值框',
          //   option: {
          //     name: "文本值框",
          //     title: "文本值框",
          //     icon: 'icon-flow',
          //     img: '/img/assets/valueText.png',
          //     data: {
          //       categories: [
          //         "苹果",
          //         "三星",
          //         "小米",
          //         "oppo",
          //         "vivo"
          //       ],
          //       series: [{
          //         name: "手机品牌",
          //         data: [
          //           1000879,
          //           3400879,
          //           2300879,
          //           5400879,
          //           3400879
          //         ]
          //       }]
          //     },
          //     dataType: 0,
          //     dataFormatter: "",
          //     dataQuery: "",
          //     dataHeader: "",
          //     stylesFormatter: "",
          //     component: {
          //       width: 600,
          //       height: 300,
          //       name: "valueText",
          //       prop: "valueText",
          //     },
          //     option: {
          //       unitColor: '#fff',
          //       unitGap: 20,
          //       unitFontSize: 16,
          //       gridX: 90,
          //       gridY: 47,
          //       gridX2: 43,
          //       gridY2: 25,
          //       legend: true,
          //       tipShow: true,
          //       xAxisShow: true,
          //       yAxisShow: true,
          //       barWidth: 30,
          //       barRadius: 0,
          //       barColor: [{
          //         color1: "#83bff6",
          //         color2: "#188df0",
          //         postion: 90
          //       }, {
          //         color1: "#23B7E5",
          //         color2: "#564AA3",
          //         postion: 50,
          //       }],
          //       barMinHeight: 2
          //     }
          //   }
          // },
          /* {
        label: '柱线组合图',
        option: {
          name: "柱线组合图",
          title: "柱线组合图",
          icon: 'icon-flow',
          img: '/img/assets/mixBar.png',
          data: {
            categories: [
              "苹果",
              "三星",
              "小米",
              "oppo",
              "vivo"
            ],
            series: [{
              name: "手机品牌",
              type: 'bar',
              data: [
                1000879,
                3400879,
                2300879,
                5400879,
                3400879
              ]
            },{
              name: "手机品牌",
              type: 'line',
              data: [
                1000879,
                3400879,
                2300879,
                5400879,
                3400879
              ]
            }]
          },
          dataType: 0,
          dataFormatter: "",
          dataQuery: "",
          dataHeader: "",
          stylesFormatter: "",
          component: {
            width: 600,
            height: 300,
            name: "mixBar",
            prop: "mixBar",
          },
          option: {
            gridX: 90,
            gridY: 47,
            gridX2: 80,
            gridY2: 25,
            legend: true,
            tipShow: true,
            xAxisShow: true,
            yAxisShow: true,
            barWidth: 30,
            barRadius: 0,
            barColor: [{
              color1: "#83bff6",
              color2: "#188df0",
              postion: 90
            }, {
              color1: "#23B7E5",
              color2: "#564AA3",
              postion: 50,
            }],
            barMinHeight: 2
          }
        }
      }, */ {
            label: '柱线组合图',
            option: {
              name: "柱线组合图新",
              title: "柱线组合图新",
              icon: 'icon-flow',
              img: '/img/assets/mixBar.png',
              // 指标维度的动态配置
              dynamicConfig: {
                // 增加的配置
                add: [
                  INDEX_DROP_TYPE.DIMENSION,
                  INDEX_DROP_TYPE.GROUP,
                  {
                    code: INDEX_DROP_TYPE.METRIC_L,
                    name: '柱状图指标（可多选）'
                  },
                  {
                    code: INDEX_DROP_TYPE.METRIC_R,
                    name: '折线图指标（可多选）'
                  },
                  INDEX_DROP_TYPE.REFERENCE,
                  INDEX_DROP_TYPE.ASSIST
                ],
                del: []
              },
              data: {
                "categories": [
                  "08-01",
                  "08-05",
                  "08-10",
                  "08-15",
                  "08-20"
                ],
                "series": [
                  {
                    "name": "产量",
                    "type": "bar",
                    "data": [
                      79,
                      69,
                      79,
                      59,
                      39
                    ]
                  },
                  {
                    "name": "销量",
                    "type": "line",
                    "data": [
                      79,
                      69,
                      79,
                      59,
                      39
                    ]
                  },
                  {
                    "name": "库存",
                    "type": "line",
                    "data": [
                      89,
                      79,
                      59,
                      99,
                      49
                    ]
                  }
                ]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "mixBarNew",
                prop: "mixBarNew",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 80,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                assistTip: true,
                scrollXFlag: false,
                barWidth: 30,
                barRadius: 0,
                yAxisLabelShow: true,
                rightAxisFontSize: 12,
                rightAxisColor: '#333333',
                rightAxisLabelShow: false,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          }, {
            label: '指标卡',
            option: {
              name: "指标卡",
              title: "指标卡",
              icon: "icon-map",
              img: '/img/assets/year.jpg',
              dataType: 0,
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_index'
              },
              data: [
                {
                  name: "2022",
                  value: 2022,
                },
                {
                  name: "2023",
                  value: 2023,
                }
              ],
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "indexCard",
                prop: "indexCard",
              },
              option: {
                cardType: CARD_TYPE.LINE,
                dataSourceType: DATA_SOURCE_TYPE.BIZ,
                selectedColorIndex: 0,
                size: "large",
                colorType: "single",
                valueSize: "mini",
                lineColor: "#3e7aff",
                customColor: "#3e7aff",
                titleFontSize: 14,
                valueFontSize: 20,
                titleColor: '#fff',
                valueColor: '#fff',
                assistColor: '#fff',
                assistFontSize: 12,
                assistDesColor: '#fff',
                assistDesFontSize: 12,
                mainAssistType: 'column'
              }
            }
          },
          {
            label: '天气',
            option: {
              name: "天气",
              title: "天气",
              icon: "icon-map",
              img: '/img/assets/weather.png',
              dataType: 0,
              data: [
                {
                  city: "南京",
                },
              ],
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 300,
                height: 20,
                name: "weather",
                prop: "weather",
              },
              option: {}
            }
          },
          {
            label: '基础表',
            code: "sheet",
            option: {
              name: "基础表",
              title: "基础表",
              icon: 'icon-table',
              img: '/img/assets/table.png',
              top: 0,
              left: 0,
              dataType: 0,
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_table'
              },
              data: {
                list: [
                  {province: "浙江", city: "杭州", type: "笔", price: 1},
                  {
                    province: "浙江",
                    city: "杭州",
                    type: "纸张",
                    price: 2,
                  },
                  {province: "浙江", city: "舟山", type: "笔", price: 17},
                  {
                    province: "浙江",
                    city: "舟山",
                    type: "纸张",
                    price: 6,
                  },
                  {province: "吉林", city: "长春", type: "笔", price: 8},
                  {
                    province: "吉林",
                    city: "白山",
                    type: "笔",
                    price: 12,
                  },
                  {province: "吉林", city: "长春", type: "纸张", price: 3},
                  {
                    province: "吉林",
                    city: "白山",
                    type: "纸张",
                    price: 25,
                  },
                  {province: "浙江", city: "杭州", type: "笔", price: 20},
                  {
                    province: "浙江",
                    city: "杭州",
                    type: "纸张",
                    price: 10,
                  },
                  {province: "浙江", city: "舟山", type: "笔", price: 15},
                  {
                    province: "浙江",
                    city: "舟山",
                    type: "纸张",
                    price: 2,
                  },
                  {province: "吉林", city: "长春", type: "笔", price: 15},
                  {
                    province: "吉林",
                    city: "白山",
                    type: "笔",
                    price: 30,
                  },
                  {province: "吉林", city: "长春", type: "纸张", price: 40},
                  {
                    province: "吉林",
                    city: "白山",
                    type: "纸张",
                    price: 50,
                  },
                ],
                columns: ["province", "city", "type", "price", "cost"],
                meta: [
                  {
                    field: "province",
                    name: "省份",
                  },
                  {
                    field: "city",
                    name: "城市",
                  },
                  {
                    field: "type",
                    name: "商品类别",
                  },
                  {
                    field: "price",
                    name: "价格",
                  },
                  {
                    field: "cost",
                    name: "成本",
                  },
                ]
              },
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "sheet",
                prop: "sheet",
              },
              option: {
                spreadSheetType: SPREAD_SHEET_TYPE.DETAIL,
                dataSourceType: DATA_SOURCE_TYPE.BIZ,
                theme: {
                  dataCell: {
                    text: {
                      fontSize: 12,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  rowCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  colCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  cornerCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  }
                },
                totals: {
                  row: {
                    showGrandTotals: false,
                  },
                  col: {
                    showGrandTotals: false,
                  }
                },
                config: {
                  rankFlag: false,
                  hierarchyType: "grid",
                  tooltip: {
                    showTooltip: true,
                  },
                  hideOrder: false,
                  style: {rowCfg: {}, colCfg: {}, cellCfg: {}}
                },
              },
              prop: {}
            }
          }, {
            label: '透视表',
            code: "sheet",
            option: {
              name: "透视表",
              title: "透视表",
              icon: 'icon-table',
              img: '/img/assets/table.png',
              top: 0,
              left: 0,
              dataType: 0,
              data: {
                list: [
                  {
                    number: 7789,
                    province: "浙江省",
                    city: "杭州市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 2367,
                    province: "浙江省",
                    city: "绍兴市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 3877,
                    province: "浙江省",
                    city: "宁波市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 4342,
                    province: "浙江省",
                    city: "舟山市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 5343,
                    province: "浙江省",
                    city: "杭州市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 632,
                    province: "浙江省",
                    city: "绍兴市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 7234,
                    province: "浙江省",
                    city: "宁波市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 834,
                    province: "浙江省",
                    city: "舟山市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 945,
                    province: "浙江省",
                    city: "杭州市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 1304,
                    province: "浙江省",
                    city: "绍兴市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 1145,
                    province: "浙江省",
                    city: "宁波市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 1432,
                    province: "浙江省",
                    city: "舟山市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 1343,
                    province: "浙江省",
                    city: "杭州市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 1354,
                    province: "浙江省",
                    city: "绍兴市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 1523,
                    province: "浙江省",
                    city: "宁波市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 1634,
                    province: "浙江省",
                    city: "舟山市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 1723,
                    province: "四川省",
                    city: "成都市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 1822,
                    province: "四川省",
                    city: "绵阳市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 1943,
                    province: "四川省",
                    city: "南充市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 2330,
                    province: "四川省",
                    city: "乐山市",
                    type: "家具",
                    sub_type: "桌子",
                  },
                  {
                    number: 2451,
                    province: "四川省",
                    city: "成都市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 2244,
                    province: "四川省",
                    city: "绵阳市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 2333,
                    province: "四川省",
                    city: "南充市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 2445,
                    province: "四川省",
                    city: "乐山市",
                    type: "家具",
                    sub_type: "沙发",
                  },
                  {
                    number: 2335,
                    province: "四川省",
                    city: "成都市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 245,
                    province: "四川省",
                    city: "绵阳市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 2457,
                    province: "四川省",
                    city: "南充市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 2458,
                    province: "四川省",
                    city: "乐山市",
                    type: "办公用品",
                    sub_type: "笔",
                  },
                  {
                    number: 4004,
                    province: "四川省",
                    city: "成都市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 3077,
                    province: "四川省",
                    city: "绵阳市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 3551,
                    province: "四川省",
                    city: "南充市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                  {
                    number: 352,
                    province: "四川省",
                    city: "乐山市",
                    type: "办公用品",
                    sub_type: "纸张",
                  },
                ],
                rows: ["province", "city"],
                columns: ["type", "sub_type"],
                values: ["number"],
                meta: [
                  {
                    field: "number",
                    name: "数量",
                  },
                  {
                    field: "province",
                    name: "省份",
                  },
                  {
                    field: "city",
                    name: "城市",
                  },
                  {
                    field: "type",
                    name: "类别",
                  },
                  {
                    field: "sub_type",
                    name: "子类别",
                  },
                ]
              },
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 600,
                height: 300,
                name: "sheet",
                prop: "sheet",
              },
              option: {
                spreadSheetType: SPREAD_SHEET_TYPE.BASIC,
                dataSourceType: DATA_SOURCE_TYPE.BIZ,
                totals: {
                  row: {
                    showGrandTotals: false,
                  },
                  col: {
                    showGrandTotals: false,
                  }
                },
                theme: {
                  dataCell: {
                    text: {
                      fontSize: 12,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  rowCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  colCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  },
                  cornerCell: {
                    text: {
                      fontSize: 13,
                      fill: '#333333',
                    },
                    cell: {
                      verticalBorderWidth: 1,
                      horizontalBorderWidth: 1,
                    },
                  }
                },
                config: {
                  hierarchyType: "grid",
                  tooltip: {
                    showTooltip: true,
                  },
                  hideOrder: false,
                  style: {rowCfg: {}, colCfg: {}, cellCfg: {}}
                },
              },
              prop: {}
            }
          },
          {
            label: '本月本年',
            option: {
              title: "本月本年",
              name: "本月本年",
              icon: "icon-tabs",
              img: '/img/assets/yearMonth.jpg',
              child: {
                index: [],
                paramName: ""
              },
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              dataType: 0,
              data: [
                {
                  label: "本月",
                  value: "1"
                },
                {
                  label: "本年",
                  value: "2"
                }
              ],
              component: {
                width: 356,
                height: 46,
                name: "yearMonthTab",
                prop: "yearMonthTab"
              },
              option: {
                componentsType: 'yearMonth',
                type: 'tabs',
                color: "#eee",
                empColor: "#4dffff",
                fontSize: 20,
                split: 8,
                empBackgroundImage: "/img/banner/banner5.png",
                backgroundImage: "/img/banner/banner4.png"
              },
            },
          },
          {
            label: '3d地图',
            option: {
              name: "3d地图",
              title: "3d地图",
              icon: "icon-map",
              img: '/img/assets/map.png',
              dataType: 0,

              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_map'
              },
              data: [
                {
                  name: "测试坐标1",
                  value: 1,
                  lng: 118.30078125,
                  lat: 36.91915611148194,
                  zoom: 1
                },
                {
                  name: "测试坐标2",
                  value: 1,
                  lng: 112.21435546875,
                  lat: 37.965854128749434,
                  zoom: 1
                }
              ],
              formatter: "(name,data)=>{\n  return '名称:'+name.data.name+name.data.value\n}",
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 800,
                height: 607,
                name: "newMap3D",
                prop: "newMap3D",
              },
              option: {
                tipBackgroundColor: "rgba(13, 255, 255, .5)",
                tipColor: "rgba(217, 38, 10, 1)",
                tipFontSize: "30",
                borderWidth: 1,
                scale: 87,
                type: 0,
                borderColor: "#0dffff",
                areaColor: "rgba(6, 29, 51, 0.59)",
                banner: true,
                bannerTime: 3000,
                fontSize: 14,
                zoom: 0.5,
                roam: true,
                empAreaColor: "rgba(35, 183, 229, 0.42)",
                empColor: "rgba(217, 38, 10, 1)",
                index: "894edc1d-d2f0-4616-962c-8e61083ada71",
                mapData: "/api/aida-basic/basicConfig/getById?id=100101230917175117008144",
                color: "rgba(13, 255, 255, 1)",
              }
            }
          },
          {
            label: '3D地球',
            option: {
              name: "3D地球",
              title: "3D地球",
              icon: "icon-map",
              img: '/img/assets/3d.png',
              dataType: 0,
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_map'
              },
              data: [],
              component: {
                width: 800,
                height: 800,
                name: "EarthMap",
                prop: "EarthMap",
              },
              option: {
                dangerCountry: true
              }
            }
          }, {
            label: '全屏',
            option: {
              name: "全屏",
              title: "全屏",
              icon: "icon-map",
              img: '/img/assets/fullscreen.png',
              dataType: 0,
              data: [],
              component: {
                width: 100,
                height: 100,
                name: "FullScreen2",
                prop: "FullScreen2",
              },
              option: {
                iconColor: '#e3f3ff',
                fontSize: 18,
              }
            }
          }, {
            label: '世界地图',
            option: {
              name: "世界地图",
              title: "世界地图",
              icon: "icon-map",
              img: '/img/assets/map.png',
              dataType: 0,
              // 指标维度的动态配置
              dynamicConfig: {
                // 指标维度配置的大分类
                type: 'type_map'
              },
              data: [
                {
                  name: "中国",
                  value: "49",
                },
                {
                  name: "沙特阿拉伯",
                  value: "6",
                },
                {
                  name: "伊拉克",
                  value: "9",
                },
                {
                  name: "印度",
                  value: "5",
                },
                {
                  name: "缅甸",
                  value: "2",
                },
                {
                  name: "乌兹别克斯坦",
                  value: "1",
                },
                {
                  name: "吉尔吉斯斯坦",
                  value: "1",
                },
                {
                  name: "法国",
                  value: "2",
                },
                {
                  name: "利比亚",
                  value: "1",
                },
                {
                  name: "埃及",
                  value: "2",
                },
                {
                  name: "尼日尼亚",
                  value: "10",
                },
                {
                  name: "埃塞俄比亚",
                  value: "4",
                },
              ],
              formatter: "(name,data)=>{\n  return name.data.name+name.data.value + '%'\n}",
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 800,
                height: 607,
                name: "worldMap",
                prop: "worldMap",
              },
              option: {
                tipBackgroundColor: "rgba(13, 255, 255, .5)",
                tipColor: "rgba(217, 38, 10, 1)",
                tipFontSize: "30",
                borderWidth: 1,
                scale: 87,
                type: 0,
                borderColor: "#0dffff",
                areaColor: "rgba(6, 29, 51, 0.59)",
                banner: true,
                bannerTime: 3000,
                fontSize: 14,
                zoom: 0.5,
                roam: true,
                empAreaColor: "rgba(35, 183, 229, 0.42)",
                empColor: "rgba(217, 38, 10, 1)",
                index: "894edc1d-d2f0-4616-962c-8e61083ada71",
                mapData: "/api/aida-basic/basicConfig/getById?id=100101230917175117008144",
                color: "rgba(13, 255, 255, 1)",
              }
            }
          },
          {
            label: '区域工厂选择器',
            option: {
              name: "区域工厂选择器",
              title: "区域工厂选择器",
              icon: 'icon-flow',
              img: '/img/assets/all_area_icon.png',
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 153,
                height: 116,
                name: "allAreaSelect",
                prop: "allAreaSelect",
              },
              option: {
                gridX: 90,
                gridY: 47,
                gridX2: 43,
                gridY2: 25,
                legend: true,
                tipShow: true,
                xAxisShow: true,
                yAxisShow: true,
                barWidth: 30,
                barRadius: 0,
                barColor: [{
                  color1: "#83bff6",
                  color2: "#188df0",
                  postion: 90
                }, {
                  color1: "#23B7E5",
                  color2: "#564AA3",
                  postion: 50,
                }],
                barMinHeight: 2
              }
            }
          },
          {
            label: '文本框',
            option: {
              name: "文本框",
              title: "文本框",
              icon: 'icon-flow',
              img: '/img/assets/text-icon.jpg',
              // 指标维度的动态配置
              dynamicConfig: {
                // 增加的配置
                type: 'type_common',
                add: [
                  {
                    code: INDEX_DROP_TYPE.DIMENSION,
                    name: '维度（可多选）',
                    multiple: true,
                  },
                ],
                del: [
                  {
                    code: INDEX_DROP_TYPE.GROUP,
                  },
                  {
                    code: INDEX_DROP_TYPE.TOTAL,
                  },
                ]
              },
              data: {
                categories: [
                  "苹果",
                  "三星",
                  "小米",
                  "oppo",
                  "vivo"
                ],
                series: [{
                  name: "手机品牌",
                  data: [
                    1000879,
                    3400879,
                    2300879,
                    5400879,
                    3400879
                  ]
                }]
              },
              dataType: 0,
              dataFormatter: "",
              dataQuery: "",
              dataHeader: "",
              stylesFormatter: "",
              component: {
                width: 153,
                height: 116,
                name: "textAreaModel",
                prop: "textAreaModel",
              },
              option: {
                fontSize: 14,
                lineHeight: 22,
                textWrap: 'wrap',
              },
              prop: {
                limit: 1
              },
            }
          },
          {
            label: '班前会',
            option: {
              name: "班前会",
              title: "班前会",
              icon: "icon-map",
              img: '/img/assets/bqh.png',
              dataType: 0,
              // 指标维度的动态配置
              dynamicConfig: {},
              data: [],
              component: {
                width: 400,
                height: 400,
                name: "BQH",
                prop: "BQH",
              },
              option: {
                titleColor: 'rgb(97, 233, 250)',
                titleFontSize: '16',
                titleFontWeight: 'bolder',
                contentColor: '#fff',
                contentFontSize: '14',
                contentFontWeight: '',
                photoWidth: '200',
                photoHeight: '',
                tipColor: 'rgb(174, 180, 189)',
                tipFontSize: '14',
                tipFontWeight: '',
              }
            }
          }
        ]
      }
    ]
}

export const url = website.url
export const aidaApiUrl = '/api'
